import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import './index.scss';
import {User, UserTypes} from '../../store/ducks/user/types';
import * as UserActions from '../../store/ducks/user/actions';

import { Redirect } from "react-router-dom";
import Api from '../../services/api';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Container, InputGroup, FormControl, Button, Image } from 'react-bootstrap'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReceipt, faUnlock, faEnvelope, faSyncAlt, faGlassCheers, faSignOutAlt, faHeart } from '@fortawesome/free-solid-svg-icons';
import { faUser, faMoneyCheckAlt, faMapMarkerAlt, faShoppingCart, faChevronDown, faBars, faSearch, faDrumstickBite } from '@fortawesome/free-solid-svg-icons'



interface StateProps { 
  user: User;
} 

interface DispatchProps {
  doLogout(): void;
}

type Props = StateProps & DispatchProps;


class UserSidebar extends Component <Props> {

  state: any = {};
  api: any = null;

  constructor (props: any) {
    super(props);

    this.api = new Api();

    this.state = {
      redirect: null,
      isLoadingCustomer: true,
      customer: null,
      hasError: false,
      hasSuccess: false,
      newsletter: '',
    }

    this.handleNewsletter = this.handleNewsletter.bind(this);
  }

  componentDidMount () {
    const self = this;
    
    if (( self.props.user ) && ( self.props.user.status !== false )) { 
      self.getCustomer();
    }

    if (( !self.props.user ) || ( self.props.user.status !== true )) { 
      self.setState({
        redirect: '/login'
      });
    }
  }

  private async getCustomer () {
    const self = this;

    self.setState({isLoadingCustomer: true});

    try {
      const {data} = await self.api.get(`/customer/${self.props.user.codigo}`);

      if ( data.status == false ) {
        throw new Error('Cadastro de cliente não localizado.');
      } else {
        self.setState({customer: data.msg});
      }

    } catch (e) {
      console.error(e);

      self.setState({
        customer: null,
        customerHasError: true,
        customerHasErrorTitle: 'Cadastro não localizado',
        customerHasErrorMsg: e.message
      });

    } finally {
      self.setState({isLoadingCustomer: false});
    }
  }


  private async handleLogout () {
    const self = this;
    self.props.doLogout();
    self.setState({redirect: "/"});
  }

  private async handleNewsletter () {
    const self = this;
    let param: any = {};

    if ( !self.state.newsletter) {
      self.setMsg( 'error', "E-mail inválido", "Insira um endereço de e-mail válido");
      return;
    }

    // Sucess code
  }

  private async setMsg ( type: string, title: string, msg: string) {
    const self = this;
    let timeout = 5000;

    if ( type === "error" ) {
      
      self.setState({
        hasError: true,
        hasErrorTitle: title,
        hasErrorMsg: msg,
      }, () => {
        setTimeout(() => self.setState({ hasError: false }), timeout)
      });

    } else {

      self.setState({
        hasSuccess: true,
        hasSuccessTitle: title,
        hasSuccessMsg: msg,
      }, () => {
        setTimeout(() => self.setState({ hasSuccess: false }), timeout)
      });

    }
  }

  render () {

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect}/>
    }

    return (
      <>
        <article className="user-sidebar">
          <h4>
          {
            this.state.customer && 
            `${this.state.customer.nome}`
          }
          </h4>
          <a href="/meu-cadastro#meu-perfil"> <FontAwesomeIcon icon={faUser} className="sidebar-icon"/> Meu Perfil </a>
          <a href="/meus-pedidos"> <FontAwesomeIcon icon={faReceipt} className="sidebar-icon"/> Meus Pedidos </a>
          <a href="/meu-cadastro#reset-senha"> <FontAwesomeIcon icon={faUnlock} className="sidebar-icon"/> Reset de Senha </a>
          <a href="/meu-cadastro#entrega"> <FontAwesomeIcon icon={faMapMarkerAlt} className="sidebar-icon"/> Endereço de Entrega </a>
          <a href="/meu-cadastro#meus-favoritos"> <FontAwesomeIcon icon={faHeart} className="sidebar-icon"/> Favoritos </a>
          <hr/>
          <span className="central-newsletter">
            <h5> Gostaria de receber atualizações, promoções, receitas e muito mais? </h5>
            <p> Inscreva-se na nossa Newsletter! </p>
            <InputGroup className="central-newsletter-container">
              <InputGroup.Prepend>
                <InputGroup.Text id="envelope-mail" className="text-input-addon">
                  <FontAwesomeIcon icon={faEnvelope}/>
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
              className="search-box-input"
              type="email"
              placeholder="Insira seu E-mail"
              aria-label="Newsletter"
              aria-describedby="Insira seu e-mail para se cadastrar em nossa newsletter"
              onChange={(event) => this.setState({newsletter: event.target.value})}/>
              <InputGroup.Prepend>
                <Button className="btn-primary-action" onClick={this.handleNewsletter}> Enviar </Button>
              </InputGroup.Prepend>
            </InputGroup>
            {
              (this.state.hasError) &&
              <p className="error-warning"> Insira um endereço de e-mail válido </p>
            }
          </span>
          <hr/>
          <a href="/fale-conosco"> Fale Conosco </a>
          <a href="/"> Política de Trocas e Devoluções </a>
          <button title="Fazer Logout" className="sidebar-logout" onClick={this.handleLogout}> <FontAwesomeIcon icon={faSignOutAlt} className="sidebar-icon"/> Sair </button>
        </article>

      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...UserActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserSidebar);